import { Component, computed, input, Signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MeasurementStateService, MeasurementType } from "@evident/ngx-media-viewer";
import { TranslateModule } from "@ngx-translate/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { SelectModule } from "primeng/select";
import { CommonModule } from "@angular/common";
import { VISOL_MEASUREMENT_TYPES } from "../measurement.type";
import { MeasurementService } from "../services/measurement.service";

@Component({
  selector: "app-measurement-picker",
  imports: [FormsModule, SelectModule, TranslateModule, CommonModule],
  templateUrl: "./measurement-picker.component.html",
  styleUrl: "./measurement-picker.component.scss",
  standalone: true
})
export class MeasurementPickerComponent {
  public disabled = input(true);
  public readonly measurementTypes = VISOL_MEASUREMENT_TYPES;
  public selectedMeasurement = computed(() => (this.isEditing() ? this.selectedMeasurementType() : null));
  private readonly selectedMeasurementType: Signal<MeasurementType | undefined>;
  private readonly isEditing: Signal<boolean>;

  constructor(
    private measurementState: MeasurementStateService,
    private measurementService: MeasurementService
  ) {
    this.selectedMeasurementType = toSignal(this.measurementState.selectedMeasurementType$);
    this.isEditing = toSignal(this.measurementState.isEditing$, { initialValue: false });
  }

  public async onMeasurementTypeChange(type: MeasurementType) {
    if (!type) return;

    await this.measurementService.completeInProgressMeasurement();

    if (this.selectedMeasurement() === type) {
      this.measurementState.disable();
      return;
    }

    this.measurementState.selectedMeasurementType = type;
    this.measurementState.enable();
  }
}
